import axios from 'axios';
import TokenService from './token.service';
import { baseURL } from '../core';
import { useEffect } from 'react';
import constants from '../Util/constants';

const userToken = localStorage.getItem('jToken');

const register = (data) => {
  return axios.post('/auth/signup', data);
};

const updateProfilePicture = (data) => {
  // `data` must be a FormData. Do NOT set Content-Type here — axios sets
  // `multipart/form-data; boundary=…` automatically for FormData. Hardcoding it
  // (without the boundary) breaks multipart parsing so the file never reaches
  // multer and the logo is saved blank.
  const headersForImage = {
    authorization: `Bearer ${userToken}`,
  };

  return axios
    .post(`${baseURL}/agent/update-profile-picture`, data, {
      headers: headersForImage,
    })
    .then((response) => {
      return response.data;
    });
};

const updateTravelAgency = (data, data1) => {
  const headersForImage = {
    authorization: `Bearer ${userToken}`,
  };

  return axios
    .post(
      `${baseURL}/travel-agency/update-travel-agencies?agency_id=${data1}`,
      data,
      {
        headers: headersForImage,
      }
    )
    .then((response) => {
      return response.data;
    });
};

const updateAgentApi = (agent_id, data) => {
  // Read at call time: update-agent now only accepts your own record, so a token left
  // over from a previous sign-in in this tab would be refused (403) instead of saving.
  const headersForupdate = {
    authorization: `Bearer ${localStorage.getItem('jToken')}`,
  };
  return axios
    .post(`${baseURL}/agent/update-agent?agent_id=${agent_id}`, data, {
      headers: headersForupdate,
    })
    .then((response) => {
      localStorage.setItem('agent', JSON.stringify(response.data.doc) || []);
      return response.data;
    });
};

const updateProfileApi = async (
  agent_id,
  agency_id,
  data,
  AgencyPayload,
  updateProfilePassword
) => {
  if (agent_id) {
    await updateAgentApi(agent_id, data);
  }

  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };

  // Update agency
  const response = await axios.post(
    `${baseURL}/travel-agency/update-travel-agencies?agency_id=${agency_id}`,
    AgencyPayload,
    {
      headers: headersForupdate,
    }
  );

  // Save updated agency data
  localStorage.setItem('travelAgency', JSON.stringify(response?.data?.data));

  // Only call the password endpoint if the user actually entered a new
  // password AND its confirmation. Empty / undefined skips the call so we
  // don't hit /agent/update-password with an empty body (BE returns 502).
  if (
    updateProfilePassword &&
    updateProfilePassword.newPass &&
    updateProfilePassword.ConfirmPass
  ) {
    await UpdatePassword(updateProfilePassword);
  }

  return response.data;
};

const UpdatePassword = async (data) => {
  console.log('Updating password');
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };

  const updatePasswordResponse = await axios.post(
    `${baseURL}/agent/update-password`,
    data,
    {
      headers: headersForupdate,
    }
  );

  return updatePasswordResponse.data;
};

const AddNewClientApi = (data) => {
  const agentId = localStorage.getItem('agent_id');
  console.log('agentId ', agentId);
  console.log('data is ', data);
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };
  return axios
    .post(`${baseURL}/client/create-client`, data, {
      headers: headersForupdate,
    })
    .then((response) => {
      return response.data;
    });
};

const UpdateClientApi = (client_id, data) => {
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };
  return axios
    .post(`${baseURL}/client/update-client?client_id=${client_id}`, data, {
      headers: headersForupdate,
    })
    .then((response) => {
      return response.data;
    });
};

const VerifyCodeApi = (data) => {
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };
  return axios
    .post(`${baseURL}/agent/verify-code`, data, {
      headers: headersForupdate,
    })
    .then((response) => {
      return response.data;
    });
};

const ChnagePasswordApi = (data) => {
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };
  return axios
    .post(`${baseURL}/agent/change-password`, data, {
      headers: headersForupdate,
    })
    .then((response) => {
      return response.data;
    });
};

const AdminReset = (data) => {
  // Read at call time, not module load: an admin who signed in without reloading
  // would otherwise send "Bearer null" and get a 401.
  const headersForupdate = {
    authorization: `Bearer ${localStorage.getItem('jToken')}`,
  };
  return axios
    .post(`${baseURL}/agent/admin-reset-password`, data, {
      headers: headersForupdate,
    })
    .then((response) => {
      return response.data;
    });
};

const GetAgency = (data) => {
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };
  return axios
    .get(`${baseURL}/travel-agency/get-travel-agencies?agency_id=${data}`, {
      headers: headersForupdate,
    })
    .then((response) => {
      return response.data;
    });
};

const GetProfile = (data) => {
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };
  return axios
    .get(`${baseURL}/agent/get-profile?agent_id=${data}`, {
      headers: headersForupdate,
    })
    .then((response) => {
      return response.data;
    });
};

// Fetch ANY agent's full record by Mongo _id (the no-id /get-profile returns the
// logged-in user; this :id variant returns the requested agent). Returns { agent }.
const GetProfileById = (id) => {
  return axios
    .get(`${baseURL}/agent/get-profile/${id}`, {
      headers: { authorization: `Bearer ${userToken}` },
    })
    .then((response) => {
      return response.data;
    });
};

const ForgotPasswordApi = (data) => {
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };
  return axios
    .post(`${baseURL}/agent/forget-password`, data, {
      headers: headersForupdate,
    })
    .then((response) => {
      return response.data;
    });
};

const GetReservation = (data) => {
  // SEC-06: printed the raw jToken.
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };
  return axios
    .get(`${baseURL}/reservation/get-reservations`, {
      params: data,
      headers: headersForupdate,
    })
    .then((response) => {
      return response.data;
    });
};

const updateReservation = (data, reservationID) => {
  // SEC-06: printed the raw jToken.
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };
  return axios
    .post(`${baseURL}/reservation/update-reservations?id=${reservationID}`, {
      params: data,
      headers: headersForupdate,
    })
    .then((response) => {
      return response.data;
    });
};
const updateReservationStatus = async (reservationID, status, extraFields = undefined) => {
  try {
    const body = {
      status,
      ...(extraFields && typeof extraFields === 'object' ? extraFields : {})
    };
    const response = await axios.put(
      `${baseURL}/reservation/update-reservation`,
      body,
      {
        params: { id: reservationID }, 
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userToken}`,
        },
      }
    );
    console.log('Reservation status updated:', response.data);
    // Backend responses vary; normalize for UI callers.
    // Typical success payload: { message: string, data: object }
    return {
      success: response?.status >= 200 && response?.status < 300,
      ...response.data,
    };
  } catch (error) {
    console.error('Error updating reservation status:', error);
    throw error;
  }
};

const preAuthPaymentCapture = async (reservationID) => {
  try {
    const response = await axios.get(
      `${baseURL}/reservation/pre-auth-flywire-capture`,
      {
        params: { id: reservationID }, 
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${userToken}`,
        },
      } 
    )
    console.log('Flywire Pre auth payment capture:', response.data)
    return response.data;
  } catch(error) {
    console.error('Error Flywire Pre auth payment capture:', error);
    throw error;
  }
}


const GetClientCstApi = (name, email, agentId) => {
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };
  // ${baseURL}
  return axios
    .get(
      `${baseURL}/client/get-clients?limit=20&agent_id=${agentId}&search=${name}&email=${email}
    `,
      {
        headers: headersForupdate,
      }
    )
    .then((response) => {
      return response.data;
    });
};

const GetSingleClientApi = (agentId, agencyId, clientId) => {
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };
  return axios
    .get(
      `${baseURL}/client/get-client?agent_id=${agentId}&agency_id=${agencyId}&client_id=${clientId}
    `,
      {
        headers: headersForupdate,
      }
    )
    .then((response) => {
      return response.data;
    });
};

const GetWishListLog = (agent_id, agency_id, agent_role, sortby, limit, skip) => {
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };
  //${baseURL}
  return axios
    .get(`${baseURL}/wishlist/get-wishlists?sortBy=${sortby}&limit=${limit}&skip=${skip}`, {
      headers: headersForupdate,
    })
    .then((response) => {
      return response.data;
    });
};

const AgentSignup = (data) => {
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };
  return axios
    .post(`${baseURL}/agent/signup`, data, {
      headers: headersForupdate,
    })
    .then((response) => {
      return response.data;
    });
};

const DestinationsOptions = () => {
  const headersForupdate = {
    authorization: `Bearer __HUB_SESSION__`,
  };
  return axios
    // ?v=<version> busts the browser HTTP cache (Cache-Control max-age=86400) so a
    // re-fetch after a DEST_CACHE_VERSION bump actually reaches the server.
    .get(constants.SHUB_URL+`/local/destinations?v=${constants.DEST_CACHE_VERSION}`, {
      headers: headersForupdate,
    })
    .then((response) => {
   // console.log('response:',response.data.data[0])
      const regions = response?.data.data[0]?.allRegions
      const countries = response?.data.data[0]?.allCountries
      const cities = response?.data.data[0]?.allCities
      localStorage.setItem('regions', JSON.stringify(regions));
      localStorage.setItem('countries', JSON.stringify(countries));
      localStorage.setItem('cities', JSON.stringify(cities));
      // Trimmed country→region→city tree with listing counts, for the "Popular
      // destinations" browse panel, the search-results tree in the destination
      // dropdown and the sidebar counts (~120KB). Sorted by count desc at every
      // level so consumers can render it as-is.
      const tree = (response?.data.data[0]?.destinations || [])
        .map((c) => ({
          name: c.countryName,
          count: c.countByCountry,
          regions: (c.regions || [])
            .map((r) => ({
              name: r.regionName,
              count: r.countByRegion,
              cities: (r.cities || [])
                .map((ct) => ({ name: ct.cityName, count: ct.count }))
                .sort((a, b) => b.count - a.count),
            }))
            .sort((a, b) => b.count - a.count),
        }))
        .sort((a, b) => b.count - a.count);
      localStorage.setItem('destinations_tree', JSON.stringify(tree));
      localStorage.setItem('destinations_ts', String(Date.now()));
      return response.data;
    });
};

const getHotDesinationsApi = () => {
  const headers = {};
  if (userToken) {
    headers.authorization = `Bearer ${userToken}`;
  }
  return axios
    .get(`${baseURL}/hotdestination/get-hotdestinations`, {
      headers,
    })
    .then((response) => {
      return response.data;
    });
};

const getHotDesinationByIdApi = (id) => {
  const headers = {};
  if (userToken) {
    headers.authorization = `Bearer ${userToken}`;
  }
  return axios
    .get(`${baseURL}/hotdestination/get-hotdestination?id=${id}`, {
      headers,
    })
    .then((response) => {
      return response.data;
    });
};

const approveAgent = (data, agent_id) => {
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };
  return axios
    .post(`${baseURL}/agent/approve-agent?agent_id=${agent_id}`, data, {
      headers: headersForupdate,
    })
    .then((response) => {
      return response.data;
    });
};

const travelAgencyApproval = (data, agency_id) => {
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };
  return axios
    .post(`${baseURL}/travel-agency/approve?agency_id=${agency_id}`, data, {
      headers: headersForupdate,
    })
    .then((response) => {
      return response.data;
    });
};

// `payload` carries the decline body — `notes` and `adminAgent` (mirrors the
// Approve payload). axios.delete is (url, config); the previous 3rd-arg
// headers were silently ignored, so we merge data + headers into one config.
const deleteAgency = (agency_id, payload = {}) => {
  // Back-compat: callers used to pass `notes` as a plain string. Wrap it.
  const body = typeof payload === 'string' ? { notes: payload } : payload;
  return axios
    .delete(`${baseURL}/travel-agency/delete-travel-agencies?agency_id=${agency_id}`, {
      data: body,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    })
    .then((response) => {
      return response.data;
    });
}

// The Decline popup's preview: both decline emails written out for this applicant, the one
// Claude's review points to (null = test or spam: decline without email), the applicant's
// address and the default CC (Asana 1219430091950241). Admin only on the backend.
const getDeclineMessage = (agency_id) => {
  return axios
    .get(`${baseURL}/travel-agency/decline-message?agency_id=${agency_id}`, {
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    })
    .then((response) => response.data);
}

// The admin popup's message step (Asana 1219400210164756): one request-to-join email, as the
// admin starts from it (the saved default or the shipped wording), its preview, and saving or
// resetting the default. Admin only on the backend.
const getDecisionMessage = (agency_id, key, missingFields = []) => {
  const params = new URLSearchParams({ agency_id: String(agency_id), key });
  if (missingFields.length) params.set('missingFields', missingFields.join(','));
  return axios
    .get(`${baseURL}/travel-agency/decision-message?${params.toString()}`, {
      headers: { authorization: `Bearer ${userToken}` },
    })
    .then((response) => response.data);
}

// data: { agency_id, key, subject, bodyHtml, missingFields }
const previewDecisionMessage = (data) => {
  return axios
    .post(`${baseURL}/travel-agency/decision-message/preview`, data, {
      headers: { authorization: `Bearer ${userToken}` },
    })
    .then((response) => response.data);
}

// data: { key, subject, bodyHtml }
const saveDecisionMessageTemplate = (data) => {
  return axios
    .put(`${baseURL}/travel-agency/decision-message-template`, data, {
      headers: { authorization: `Bearer ${userToken}` },
    })
    .then((response) => response.data);
}

const resetDecisionMessageTemplate = (key) => {
  return axios
    .delete(`${baseURL}/travel-agency/decision-message-template?key=${encodeURIComponent(key)}`, {
      headers: { authorization: `Bearer ${userToken}` },
    })
    .then((response) => response.data);
}

// Every email sent to one applicant, newest first, with its text (Asana 1220123284484901).
// Admin only on the backend. Answers { agency_id, emails: [...] }.
const getDecisionEmails = (agency_id) => {
  return axios
    .get(`${baseURL}/travel-agency/decision-emails?agency_id=${encodeURIComponent(agency_id)}`, {
      headers: { authorization: `Bearer ${userToken}` },
    })
    .then((response) => response.data);
}

// The admin dashboard's Emails page (Asana 1220139976043710): every email sent to partners,
// newest first, paged, searchable by partner name or address, with reply counts and how the last
// read of the reply inbox went. Admin only on the backend.
// Answers { total, skip, limit, emails: [...], intake: { lastRunAt, lastOkAt, lastError } }.
const getEmailLog = ({ q = "", skip = 0, limit = 25 } = {}) => {
  return axios
    .get(`${baseURL}/travel-agency/email-log`, {
      params: { q: q || undefined, skip, limit },
      headers: { authorization: `Bearer ${userToken}` },
    })
    .then((response) => response.data);
}

const trianglLuxuryApi = (data) => {
  const token2 =
    constants.SHUB_STATIC_TOKEN;
  const headersForupdate = {
    Authorization: `Bearer ${token2}`,
  }; 
  return axios
    .get(constants.SHUB_URL+'/local/listings?'+data, {
      headers: headersForupdate,
    })
    .then((response) => {
      return response.data;
    });
};

const sendEmailApi = (data) => {
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };
  return axios
    .post(`${baseURL}/email/send-email`, data, {
      headers: headersForupdate,
    })
    .then((response) => {
      return response.data;
    });
};

// Notify an applicant whose profile is incomplete, before approval.
// data: { role: 'travel_pro' | 'property_manager', agency_id, recipientEmail,
//         name, cc, missingFields: string[], message?: { key, subject, bodyHtml, cc } }
const notifyIncompleteProfile = (data) => {
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };
  return axios
    .post(`${baseURL}/travel-agency/notify-incomplete-profile`, data, {
      headers: headersForupdate,
    })
    .then((response) => {
      return response.data;
    });
};

// Re-run the AI due-diligence check for one agency. Advisory only -- it never
// changes the agency status; Approve/Decline stays a human click. Admin-gated
// on the backend because it spends money and fetches a third-party URL.
const rerunDueDiligence = (agency_id) => {
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };
  return axios
    .post(`${baseURL}/travel-agency/due-diligence/${agency_id}`, {}, {
      headers: headersForupdate,
    })
    .then((response) => {
      return response.data;
    });
};

const hotdestinationAddLikeApi = (id) => {
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };
  return axios
    .patch(
      `${baseURL}/hotdestination/add-one-like?id=${id}`,
      {},
      {
        headers: headersForupdate,
      }
    )
    .then((response) => {
      return response.data;
    });
};

const hotdestinationRemoveLikeApi = (id) => {
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };
  return axios
    .delete(`${baseURL}/hotdestination/remove-one-like?id=${id}`, {
      headers: headersForupdate,
    })
    .then((response) => {
      return response.data;
    });
};

const AddSubAgentApi = (data) => {
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };
  return axios
    .post(`${baseURL}/agent/add-sub-agent`, data, {
      headers: headersForupdate,
    })
    .then((response) => {
      return response.data;
    });
};


const addWishListAPi = (data) => {
  const headersForupdate = {
    authorization: `Bearer ${userToken}`,
  };
  
  return axios
    .post(`${baseURL}/wishlist/add-wishlist`, data, {
      headers: headersForupdate,
    })
    .then((response) => {
      return response.data;
    });
};

const AuthService = {
  hotdestinationAddLikeApi,
  hotdestinationRemoveLikeApi,
  sendEmailApi,
  GetWishListLog,
  AgentSignup,
  GetReservation,
  updateReservation,
  updateReservationStatus,
  preAuthPaymentCapture,
  register,
  updateProfilePicture,
  updateProfileApi,
  AddNewClientApi,
  GetProfile,
  GetProfileById,
  GetAgency,
  DestinationsOptions,
  updateTravelAgency,
  GetClientCstApi,
  GetSingleClientApi,
  getHotDesinationsApi,
  getHotDesinationByIdApi,
  approveAgent,
  UpdateClientApi,
  VerifyCodeApi,
  ChnagePasswordApi,
  ForgotPasswordApi,
  travelAgencyApproval,
  trianglLuxuryApi,
  AddSubAgentApi,
  addWishListAPi,
  AdminReset,
  deleteAgency,
  getDeclineMessage,
  getDecisionMessage,
  previewDecisionMessage,
  saveDecisionMessageTemplate,
  resetDecisionMessageTemplate,
  getDecisionEmails,
  getEmailLog,
  notifyIncompleteProfile,
  rerunDueDiligence
};

export default AuthService;
